import React from "react";
import "./radioButton.css";

const RadioButton = ({ label, name, value, checked, onChange }) => {
  return (
    <div className="custom-radio-container">
      {/* Hidden native radio input */}
      <input
        type="radio"
        id={value}
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
      />

      {/* Label that displays the custom radio styling via CSS */}
      <label htmlFor={value}>{label}</label>
    </div>
  );
};

export default RadioButton;
